import { ILayoutComponent, LayoutComponentNames } from '@diana/core';

export const isSectionComponent = (
  value: (Partial<ILayoutComponent> & Pick<ILayoutComponent, 'component'>) | null,
) => {
  if (value) {
    return (
      value.component === LayoutComponentNames.SECTION ||
      value.component === LayoutComponentNames.SECTION_REPEATER
    );
  }
  return false;
};
